import React from "react";
import PropTypes from "prop-types";
import { TvDiv, TvP } from "@trustvid/design-system";
import { useActiveAccountId } from "../../context/account-branding-context";
import { useSaasEntitlements } from "../../hooks/useSaasEntitlements";
import { getUserData } from "../../utils/auth-helpers";
import { resolveSaasFeatureAccess, SAAS_FEATURE_GATE } from "../../utils/saasFeatureAccess";
import SaasModuleLock, { SaasModuleChrome, SaasModuleFooter } from "./SaasModuleLock";

/** Route-level gate: Free accounts see Unlock UI; Premium sees the real module. */
const SaasFeatureGate = ({
  gate = SAAS_FEATURE_GATE.paid,
  label,
  group,
  blurb,
  children,
}) => {
  const accountId = useActiveAccountId();
  const saasEntitlementsState = useSaasEntitlements(accountId) || {};
  const entitlements = saasEntitlementsState.entitlements || {};
  const isLoading = Boolean(saasEntitlementsState.isLoading);
  const role = getUserData()?.role;
  const access = resolveSaasFeatureAccess({ gate, entitlements, role });

  if (isLoading) {
    return (
      <TvDiv className="page-content tv-saas-module" data-testid="saas-feature-gate-loading">
        <SaasModuleChrome group={group} label={label} blurb={blurb} />
        <TvP className="text-muted">Loading…</TvP>
      </TvDiv>
    );
  }

  if (!access.unlocked) {
    return (
      <TvDiv className="page-content tv-saas-module" data-testid="saas-feature-lock">
        <SaasModuleChrome group={group} label={label} blurb={blurb} />
        <SaasModuleLock label={label} badge={access.badge} cta={access.cta} />
        <SaasModuleFooter />
      </TvDiv>
    );
  }

  return children;
};

SaasFeatureGate.propTypes = {
  gate: PropTypes.string,
  label: PropTypes.string.isRequired,
  group: PropTypes.string,
  blurb: PropTypes.string,
  children: PropTypes.node,
};

export default SaasFeatureGate;
